<img obgImageContent="general.login-limits" />

<h1 class="obg-m-login-forty-days-review-dialog-heading">{{ "login.verification" | translate }}</h1>

<p class="obg-m-login-forty-days-review-dialog-notification">
	{{ "login.documents" | translate }}
</p>

<p class="obg-m-login-forty-days-review-dialog-description">
	{{ "login.verification-description" | translate }}
</p>

<button class="obg-m-login-forty-days-review-dialog-button" mat-flat-button (click)="onVerifyIdentityClick()">
	{{ "login.verify-identity" | translate }}
</button>
<button class="obg-m-login-forty-days-review-dialog-button button-continue" mat-flat-button (click)="onContinueClick()">
	{{ "login.continue-anyway" | translate }}
</button>
